import React, { Component } from 'react';
import { Grid, Header, Image, Segment, Container, Transition, Button } from 'semantic-ui-react';

const iphone=require('../../img/iphoneicon.svg');

class Contact extends Component {
  render() {
    return (
      <div>
        <Segment id='contact' style={{ padding: '8em 0em', backgroundColor:'#5AD0D2' }} vertical>
          <Container text style={{backgroundColor:'#5AD0D2'}}>
              <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}>Get in touch. </Header>
              <Grid columns='equal' stackable>
                <Grid.Row textAlign='center'>
                  <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                    <Transition animation='browse right' duration={1500} visible={true} transitionOnMount={true}>
                      <Image src={iphone} size='large'/>
                    </Transition>
                  </Grid.Column>
                  <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                    <Header as='h3' style={{ fontSize: '2em' }}>hello@beemabroker.com</Header>
                    <br/>
                    <Header as='h3' style={{ fontSize: '2em' }}>1.510.629.1377</Header>
                      <a href='/home#request-acesss'>
                        <Button compact inverted>
                          Join Private Beta
                        </Button>
                      </a>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
        </Segment>
      </div>
    );
  }
};

export default Contact;



// WEBPACK FOOTER //
// ./src/js/Home/Contact.js